module.exports = __webpack_public_path__ + "src/assets/games/42/11.jpg";